var map = {
	"./book/A4-P/sombra-lombada-interna.svg": 680,
	"./book/A4-R/sombra-lombada-interna.svg": 681,
	"./book/A5-P/sombra-lombada-interna.svg": 682,
	"./book/A5-R/sombra-lombada-interna.svg": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;